<span class="score-counter"><span *ngIf="participant1Score !== undefined" [msValueSlider]="participant1Score" [eventId]="eventId"></span></span>
<span class="score-separator" *ngIf="showSeparator"> - </span>
<span class="score-counter"><span *ngIf="participant2Score !== undefined" [msValueSlider]="participant2Score" [eventId]="eventId"></span></span>
